/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail units reducer
 */

import { nullReducer } from '@zcode/reducers'
import type { UnitsWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_ENTITY } from '../../entity/constants/index'
import { CLEAR_UNITS, RECEIVE_UNITS } from '../constants/index'
import { default as metaReducer } from './meta'
import type { ActionTypes } from './types'

export const unitsReducer = combineReducers<UnitsWithMeta, ActionTypes>({
  data: handleActions<UnitsWithMeta['data'], ActionTypes>(
    {
      [CLEAR_UNITS]: nullReducer,
      [CLEAR_ENTITY]: nullReducer,
      [RECEIVE_UNITS]: (state, { payload: { buildingId, units } }) => {
        if (!state) {
          return units
        }
        const newUnitIds = new Set(units.map(({ unitId }) => unitId))
        return state
          .filter((other) => other.buildingId === buildingId && !newUnitIds.has(other.unitId))
          .concat(units)
      },
    },
    null // schema had default of ImList()
  ),
  meta: metaReducer,
})
